import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';

const formatDay = (value) =>
    new Date(`${value}T00:00:00`).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });

const SavesActivityChart = ({ data = [], loading = false }) => {
    const series = useMemo(() => [{ name: 'Saves', data: data.map((row) => row.count) }], [data]);
    const options = useMemo(() => ({
        chart: { type: 'area', height: 280, toolbar: { show: false }, zoom: { enabled: false } },
        colors: ['#0789d5'],
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2 },
        fill: { type: 'gradient', gradient: { opacityFrom: 0.3, opacityTo: 0.02 } },
        grid: { borderColor: '#e2e8f0', strokeDashArray: 3 },
        xaxis: {
            categories: data.map((row) => formatDay(row.date)),
            tickAmount: 6,
            axisBorder: { show: false },
            axisTicks: { show: false },
            labels: { rotate: 0, hideOverlappingLabels: true, style: { colors: '#64748b', fontSize: '12px' } }
        },
        yaxis: {
            min: 0,
            forceNiceScale: true,
            labels: { formatter: (value) => Math.round(value).toString(), style: { colors: '#64748b', fontSize: '12px' } }
        },
        tooltip: { y: { formatter: (value) => `${value} ${value === 1 ? 'save' : 'saves'}` } }
    }), [data]);

    return (
        <div className="card h-100 radius-8 border-0">
            <div className="card-body p-24">
                <h6 className="mb-1 fw-bold text-lg">Saves Activity</h6>
                <span className="text-sm text-secondary-light">Venue and content saves over the last 30 days</span>
                <div className="mt-16">
                    {loading ? (
                        <div className="text-center py-5 text-secondary-light">Loading...</div>
                    ) : (
                        <ReactApexChart options={options} series={series} type="area" height={280} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default SavesActivityChart;
